/**
 * Discrete zoom levels for professional timeline navigation.
 * Values are pxPerMs (pixels per millisecond).
 */
export const ZOOM_LEVELS = [
  0.005,  // 5px per second — full overview
  0.01,   // 10px per second
  0.025,  // 25px per second
  0.05,   // 50px per second
  0.1,    // 100px per second (default)
  0.2,    // 200px per second
  0.4,    // 400px per second
  0.8,    // 800px per second — frame-level editing
  1.5,    // 1500px per second — sample-level precision
] as const;

export function nearestZoomLevel(pxPerMs: number): number {
  let closest: number = ZOOM_LEVELS[0];
  let minDist = Math.abs(Math.log(pxPerMs) - Math.log(closest));
  for (let i = 1; i < ZOOM_LEVELS.length; i++) {
    const dist = Math.abs(Math.log(pxPerMs) - Math.log(ZOOM_LEVELS[i]));
    if (dist < minDist) {
      minDist = dist;
      closest = ZOOM_LEVELS[i];
    }
  }
  return closest;
}

export function zoomIn(current: number): number {
  for (const level of ZOOM_LEVELS) {
    if (level > current * 1.01) return level;
  }
  return ZOOM_LEVELS[ZOOM_LEVELS.length - 1];
}

export function zoomOut(current: number): number {
  for (let i = ZOOM_LEVELS.length - 1; i >= 0; i--) {
    if (ZOOM_LEVELS[i] < current * 0.99) return ZOOM_LEVELS[i];
  }
  return ZOOM_LEVELS[0];
}
